import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  selectedIndex: 0, // Default to index 0
  leftNavOpen: true, // Default state of LeftNav is open
  currentPage: "Dashboard", // Default page
  breadcrumbs: [], // For navigation paths like Templates -> Create
};

const leftNavSlice = createSlice({
  name: "leftNav",
  initialState,
  reducers: {
    setSelectedIndex: (state, action) => {
      state.selectedIndex = action.payload;
    },
    toggleLeftNav: (state, action) => {
      state.leftNavOpen = action.payload;
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setBreadcrumbs: (state, action) => {
      state.breadcrumbs = action.payload;
    },
  },
});

export const {
  setSelectedIndex,
  toggleLeftNav,
  setCurrentPage,
  setBreadcrumbs,
} = leftNavSlice.actions;

export default leftNavSlice.reducer;
